module.exports = __webpack_public_path__ + "img/section4-img1.81aab3ab.png";